import {
  RewardProgramFilterKey,
  RewardStatusArray,
} from '@/api/Trading-Accounts/Types/RewardsHubDto'
import { SelectFilter } from '@/components/Filter/SelectFilter'
import { TrackingMetricsFilter } from '@/routes/Marketing/RewardsHub/RewardPrograms/TrackingMetricsFilter'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from '@/types/GridFilterOperatorEnum'
import { FilterDescriptor } from '@progress/kendo-data-query'
import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'

interface FilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

const ProgramStatus = ({ filter, onFilterChange }: FilterProps) => {
  const data = RewardStatusArray.map((x) => ({
    id: x.id.toString(),
    label: x.name,
    value: x.id,
  }))

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}

export const rewardProgramsFilteringFields = (): FieldSettings[] => [
  {
    name: RewardProgramFilterKey.INTERNAL_NAME,
    label: 'Internal Name',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
    ],
  },
  {
    name: RewardProgramFilterKey.PROGRAM_STATUS,
    label: 'Program Status',
    filter: ProgramStatus,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: RewardProgramFilterKey.TRACKING_METRICS,
    label: 'Tracking Metric',
    filter: TrackingMetricsFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: RewardProgramFilterKey.NUMBER_OF_TIERS,
    label: 'Number of Tiers',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.gtOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.ltOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
    ],
  },
]
